<template>
  <div class="timeline-section">
    <div class="timeline-inner">
      <div class="timeline-header reveal">
        <span class="section-eyebrow center">Our Journey</span>
        <h2 class="timeline-title">How We Got Here</h2>
        <p class="timeline-sub">
          From a living-room idea to 10,000+ happy customers
        </p>
      </div>
      <div class="timeline-track" ref="timelineTrack">
        <div class="timeline-progress" ref="timelineProgress"></div>

        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="timeline-item"
          :class="{ 'tl-reverse': idx % 2 === 1 }"
        >
          <div class="tl-left">
            <template v-if="idx % 2 === 0">
              <div class="tl-content" :class="{ visible: activeItems[idx] }">
                <span class="tl-tag">{{ item.tag }}</span>
                <h3 class="tl-heading">{{ item.heading }}</h3>
                <p class="tl-body">{{ item.body }}</p>
              </div>
            </template>
            <template v-else>
              <span class="tl-year tl-year-right">{{ item.year }}</span>
            </template>
          </div>
          <div class="tl-center">
            <div
              class="tl-dot"
              :class="[
                { active: activeItems[idx] },
                item.yellow ? 'yellow' : '',
              ]"
            ></div>
          </div>
          <div class="tl-right">
            <template v-if="idx % 2 === 0">
              <span class="tl-year tl-year-left">{{ item.year }}</span>
            </template>
            <template v-else>
              <div class="tl-content" :class="{ visible: activeItems[idx] }">
                <span class="tl-tag">{{ item.tag }}</span>
                <h3 class="tl-heading">{{ item.heading }}</h3>
                <p class="tl-body">{{ item.body }}</p>
              </div>
            </template>
          </div>
          <div class="tl-mobile-content">
            <span class="tl-tag">{{ item.tag }} · {{ item.year }}</span>
            <h3 class="tl-heading">{{ item.heading }}</h3>
            <p class="tl-body">{{ item.body }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutTimeline",
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTrackEl() {
      return this.$refs.timelineTrack;
    },
    getProgressEl() {
      return this.$refs.timelineProgress;
    },
  },
};
</script>
